import turfDestination from "@turf/destination";
import { clone, concat } from "lodash";

export const paymentToPence = (number) => {
  const numberInPence = Number(number) * 100;
  return numberInPence;
};

export const getTreesPlanted = (amountDonated) => {
  const costPerTree = 0.124;
  const operationalCostPercentage = 0.2;
  const costs = amountDonated * operationalCostPercentage;
  const moneyForTrees = amountDonated - costs;
  return moneyForTrees / costPerTree;
};
export const getCarbonOffset = (amountDonated, unit) => {
  const treesPlanted = getTreesPlanted(amountDonated);
  const offsetPerTree = 0.16; //tonne
  const kgPerTonne = 1000;
  // https://www.greenenergyconsulting.co.uk/treeplanting.php#:~:text=The%20amount%20of%20CO2%20a,time%20(approximately%20100%20years).
  // Trees for Life calculates 6 trees offset 1 tonne of CO2. So 1 Tree = 0.16 tonnes CO2
  if (unit === "tonnes") return treesPlanted * offsetPerTree;
  else return treesPlanted * offsetPerTree * kgPerTonne;
};

export const calculateForestArea = (treesPlanted) => {
  const metresInKm = 1000;
  const treeWidth = 2.5 / metresInKm;
  const treeHeight = 2.5 / metresInKm;
  const areaPerTree = treeHeight * treeWidth;

  const totalArea = treesPlanted * areaPerTree;
  return totalArea;
};

export const getPolygonCoordinatesFromArea = (topLeftCoordinate, area) => {
  const topLeft = {
    type: "Feature",
    properties: {},
    geometry: {
      type: "Point",
      coordinates: topLeftCoordinate,
    },
  };

  const sideLength = Math.sqrt(area);

  const topRight = turfDestination(topLeft, sideLength, 90);
  const bottomRight = turfDestination(topRight, sideLength, 180);
  const bottomLeft = turfDestination(bottomRight, sideLength, 270);

  const coordinates = [topLeft, topRight, bottomRight, bottomLeft];

  return coordinates;
};

export const getRandomColour = () => {
  const golden_ratio_conjugate = 0.618033988749895;
  let h = Math.random();
  h += golden_ratio_conjugate;
  h %= 1;

  const rgb = hsv_to_rgb(h, 0.5, 0.95);
  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]);
};
const hsv_to_rgb = (h, s, v) => {
  let h_i = Math.round(h * 6);

  let f = h * 6 - h_i;
  let p = v * (1 - s);
  let q = v * (1 - f * s);
  let t = v * (1 - (1 - f) * s);
  let r = 0;
  let g = 0;
  let b = 0;

  switch (h_i) {
    case 0:
      r = v;
      g = t;
      b = p;
      break;
    case 1:
      r = q;
      g = v;
      b = p;
      break;
    case 2:
      r = q;
      g = v;
      q = p;
      break;
    case 3:
      r = p;
      g = q;
      b = v;
      break;
    case 4:
      r = t;
      g = p;
      b = v;
      break;
    case 5:
      r = v;
      g = p;
      v = q;
      break;
    default:
      r = v;
      g = t;
      b = p;
      break;
  }
  return [
    Math.min(Math.round(r * 256), 255),
    Math.min(Math.round(g * 256), 255),
    Math.min(Math.round(b * 256), 255),
  ];
};
function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export const addTheirDonationToDonations = (allForestDonations, theirDonationAmount) => {
  const theirDonationInfo = {
    displayName: true,
    donationAmount: Number(theirDonationAmount),
    id: "TheirDonation",
    name: "You",
  };

  const newForestDonations = concat(clone(allForestDonations), theirDonationInfo);
  return newForestDonations;
};
